import "./polyfills"
import "./js/sentry"
import "./js/plausible"
import * as Sentry from "@sentry/react"
import "./index.css"
import "./i18n.config"
import React from "react"
import { createRoot } from "react-dom/client"
import { createRoutesFromElements, Navigate, Route, RouterProvider } from "react-router"
import { LayoutContext } from "./context"
import { ErrorTemplate } from "./components/templates/Error"
import { AdminLayout } from "./components/templates/AdminLayout"
import { Domain } from "./domain"

import { Component as RootPage } from "./pages/Root"
import { Component as AuthProtectedRoutes } from "./pages/AuthProtectedRoutes"
import { Component as LoginPage } from "./pages/Login"
import { Component as ErrorPage } from "./pages/Error"

import { loader as rootLoader } from "./pages/Root/loader"
import { loader as authProtectedRoutesLoader } from "./pages/AuthProtectedRoutes/loader"
import { loader as loginLoader } from "./pages/Login/loader"

import { sentryCreateBrowserRouter } from "./js/sentry"

window.domain =
  window.domain ??
  Domain.create({
    GRAPHQL_URI: import.meta.env.VITE_GRAPHQL_URI,
  })

const router = sentryCreateBrowserRouter(
  createRoutesFromElements(
    <>
      <Route id="root" loader={rootLoader} element={<RootPage />} errorElement={<ErrorTemplate />}>
        <Route path="sign-in" element={<LoginPage />} loader={loginLoader} />

        <Route element={<AuthProtectedRoutes />} loader={authProtectedRoutesLoader} shouldRevalidate={() => true}>
          <Route element={<AdminLayout />}>
            <Route index element={<Navigate to="/votings" replace />} />
            <Route path="votings" lazy={async () => import("./pages/Votes")} />
            <Route path="votings/new" lazy={async () => import("./pages/VoteCreate")} />
            <Route path="votings/:id" lazy={async () => import("./pages/VoteEdit")} />
            <Route path="blockchain" lazy={async () => import("./pages/Safe")} />
            <Route path="safe" element={<Navigate to="/blockchain" replace />} />
          </Route>
        </Route>

        <Route path="*" element={<ErrorPage />} />
      </Route>
    </>,
  ),
)

const App = () => {
  return (
    <React.StrictMode>
      <LayoutContext>
        <RouterProvider router={router} />
      </LayoutContext>
    </React.StrictMode>
  )
}

const container = document.getElementById("root")!
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack)
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
})
root.render(<App />)
